import { render, staticRenderFns } from "./custom-company-activity.vue?vue&type=template&id=20fcbca1&scoped=true&"
import script from "./custom-company-activity.vue?vue&type=script&lang=js&"
export * from "./custom-company-activity.vue?vue&type=script&lang=js&"
import style0 from "./custom-company-activity.vue?vue&type=style&index=0&id=20fcbca1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fcbca1",
  null
  
)

export default component.exports